import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "../_fri/layout/main-layout/MainLayout";
import {LinearProgress} from "@mui/material";
import EcommercePage from "../modules/ecommerce/EcommercePage";
const QrPage = React.lazy(()=>import('../modules/qr/QrPage'));
export const PrivateRoute = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route
          path="auth/*"
          element={<Navigate to="/qr" />}
        />

        <Route path="qr/*" element={<React.Suspense fallback={ <LinearProgress />}> <QrPage/></React.Suspense>} />

        <Route path="ecommerce/*" element={<React.Suspense fallback={ <LinearProgress />}><EcommercePage/></React.Suspense>} />

        <Route path="*" element={<Navigate to="/"/>}/>
      </Route>
    </Routes>
  );
};
